const Settings = {
  WIDTH: 1080,
  HEIGHT: 1920,
  // WIDTH: 375,
  // HEIGHT: 812,
  MAX_MOBILE_WIDTH: 400,

  //For Portrait Detection
  DESKTOP_MINIMUM_WIDTH: 768,
};

export default Settings;
